import { render, staticRenderFns } from "./drawuser-upload.vue?vue&type=template&id=47dd6001"
import script from "./drawuser-upload.vue?vue&type=script&lang=js"
export * from "./drawuser-upload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports